<template>
    <div>
      <v-alert  type="warning" text v-if="exibeAlertDocsObrigatorios">Os seguintes documentos são obrigatórios:
        <ul>
          <li v-for="doc in docsObrigatorios" :key="doc.value">{{ doc.text }}</li>
        </ul>
      </v-alert>
      <v-alert v-else-if="alertText && showAlert" type="warning" text>{{ alertText }}</v-alert>
      <core-grid
        ref="grid"
        :onRead="onRead"
        :schema="schema"
        :mobile-breakpoint="0"
        modal
        flat
        :hide-all-options="resumo"
        :hide-default-footer="resumo"
        :grid-role="tipo.gridRole"
        :search-disabled="tipo.searchDisabled"
      >
        <template v-slot:[`item.TipoDocumento`]="{ item }">
          <v-icon class="mr-2" size="dense" @click="downloadDocumento(item)">fas fa-file-download</v-icon>
          <a @click="downloadDocumento(item)">
            {{$aux.TipoDocumento.find(p => p.value === item.TipoDocumento)?.text || item.TipoDocumentoDescricao}}
          </a>
        </template>
      </core-grid>
      <DocumentoEdit
        :hasEdit="hasEdit"
        ref="editar"
        :tipo="tipo"
        :codigoProposta="codigoProposta"
        :documentoCliente="documentoCliente"
        :validadeRequired="validadeRequired"
        :codigoPessoa="codigoPessoa"
        @close="response"
      />
    </div>
  </template>

<script>
export default {
  components: {
    DocumentoEdit: () => import('./DocumentoEdit')
  },
  props: {
    alertText: { type: String, default: null },
    tipo: { type: Object, required: true }, // 'pessoa' ou 'proposta'
    resumo: { type: Boolean, default: false },
    codigoProposta: null,
    codigoPessoa: null,
    documentoCliente: null,
    hasEdit: { type: Boolean, default: false },
    validadeRequired: { type: Boolean, default: false },
    exibeAlertaDocsObrigatorios: { type: Boolean, default: false }
  },
  data () {
    return {
      docsObrigatorios: [],
      showAlert: true
    }
  },
  computed: {
    exibeAlertDocsObrigatorios () {
      return this.docsObrigatorios?.length >= 1 && (this.exibeAlertaDocsObrigatorios && !this.resumo)
    },
    tipoPessoa () {
      return this.$api.UI.Format.SomenteNumeros(this.documentoCliente).length === 11 ? this.$aux.TipoPessoaEnum.PF : this.$aux.TipoPessoaEnum.PJ
    },
    listaDocumentosObrigatorios () {
      if (this.tipo === this.$aux.TipoDocumentoEntidade.Pessoa) {
        return this.$param.ListaDocumentoEmitente.filter((doc) => doc.obrigatorio === true && (doc.tipoPessoa === this.tipoPessoa || doc.tipoPessoa === this.$aux.TipoEntidadeDocumentoEnum.DocumentosAmbos));
      } return this.$param.ListaDocumentoProposta.filter((doc) => doc.obrigatorio === true);
    },
    schema () {
      return [
        { value: 'TipoDocumento', text: 'Tipo Documento' },
        { value: 'NomeArquivo', text: 'Nome Arquivo' },
        { value: 'DtValidade', text: 'Válido até', format: 'date' },
      ];
    },
  },
  methods: {
    async onRead (options) {
      const th = this
      const dto = th.getParameters();
      if (dto) {
        th.$api.Multiplo.Post(th.tipo.apiEndpoint, dto).then(async function (response) {
          if (th.$api.UI.PostLoadData(response)) {
            const listaFiltrada = response.Data.filter(doc => !doc.NomeArquivo?.includes('Representante Legal') && !doc.NomeArquivo?.includes('Avalista'))
            options.success(listaFiltrada);
            listaFiltrada.length > 0 ? th.showAlert = false : th.showAlert = true
            if (th.exibeAlertaDocsObrigatorios && !th.resumo) {
              await th.refreshDocsObrigatorios();
            }
          }
        });
      } else {
        options.success([]);
        if (th.exibeAlertaDocsObrigatorios && !th.resumo) {
          await th.refreshDocsObrigatorios();
        }
      }
    },
    async refreshDocsObrigatorios () {
      const th = this;

      const documentosEnviados = th.$refs.grid.dataSource || [];

      th.docsObrigatorios = th.listaDocumentosObrigatorios.filter(docObrigatorio => {
        return !documentosEnviados.find(docEnviado => docEnviado.TipoDocumento === docObrigatorio.value);
      });
    },
    getParameters () {
      const th = this
      if (th.tipo === th.$aux.TipoDocumentoEntidade.Pessoa && th.codigoPessoa) {
        return {
          parameters: [
            { name: 'CodigoPessoa', value: th.codigoPessoa },
            { name: 'CodigoProposta', value: th.codigoProposta },
          ],
        };
      } else if (th.tipo === th.$aux.TipoDocumentoEntidade.Proposta && th.codigoProposta) {
        return {
          parameters: [{ name: 'CodigoProposta', value: th.codigoProposta }],
        };
      }
    },
    refresh () {
      this.$refs.grid.refresh();
    },
    response (data) {
      if (data) {
        this.refresh();
      }
    },
    downloadDocumento (item) {
      window.open(`${process.env.VUE_APP_ROOT_WEBURL}download.aspx?type=${this.tipo.tipoDownloadDoc}&code=${item.Codigo}`);
    },
    excluir (current) {
      const th = this
      if (current) {
        const dto = {
          guidID: current.Codigo
        }
        th.$api.Multiplo.Post(th.tipo.apiRemoverDocumento, dto).then(function (data) {
          if (th.$api.UI.PostAction(data)) {
            th.refresh()
          }
        })
      }
    }
  },
};
</script>
